import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the staciIllustrationPage state domain
 */

const selectStaciIllustrationPageDomain = state =>
  state.get('staciIllustrationPage', initialState);

/**
 * Other specific selectors
 */
const makeSelectLifeAssured = () =>
  createSelector(selectStaciIllustrationPageDomain, substate =>
    substate.get('lifeAssured').toJS(),
  );

const makeSelectInitialLifeAssured = () =>
  createSelector(selectStaciIllustrationPageDomain, substate =>
    substate.get('initialLifeAssured').toJS(),
  );

const makeSelectError = () =>
  createSelector(selectStaciIllustrationPageDomain, substate =>
    substate.get('errorData').toJS(),
  );

const makeSelectProductConfig = () =>
  createSelector(selectStaciIllustrationPageDomain, substate =>
    substate.get('productConfig').toJS(),
  );

const makeSelectConfigDetail = () =>
  createSelector(selectStaciIllustrationPageDomain, substate =>
    substate.get('configsDetail').toJS(),
  );

const makeSelectQuoteId = () =>
  createSelector(selectStaciIllustrationPageDomain, substate =>
    substate.get('quoteId'),
  );

const makeSelectApplicationId = () =>
  createSelector(selectStaciIllustrationPageDomain, substate =>
    substate.get('applicationId'),
  );

const makeSelectBiPdf = () =>
  createSelector(selectStaciIllustrationPageDomain, substate =>
    substate.get('benefitIllustrationPdf'),
  );

const makeSelectStatus = () =>
  createSelector(selectStaciIllustrationPageDomain, substate =>
    substate.get('status'),
  );

const makeSelectReferenceNumber = () =>
  createSelector(selectStaciIllustrationPageDomain, substate =>
    substate.get('referenceNumber'),
  );

const makeSelectCloneStatus = () =>
  createSelector(selectStaciIllustrationPageDomain, substate =>
    substate.get('successClone'),
  );

const makeSelectemailSentStatus = () =>
  createSelector(selectStaciIllustrationPageDomain, substate =>
    substate.get('emailSent'),
  );

const makeSelectEmailErrorMessage = () =>
  createSelector(selectStaciIllustrationPageDomain, substate =>
    substate.get('emailErrorMessage'),
  );

const makeSelectIsCalculateQuotePage = () =>
  createSelector(selectStaciIllustrationPageDomain, substate =>
    substate.get('isCalculateQuotePage'),
  );

const makeSelectCompletedDialog = () =>
  createSelector(selectStaciIllustrationPageDomain, substate =>
    substate.get('completedDialog'),
  );

/**
 * Default selector used by DtaIllustrationPage
 */
export {
  selectStaciIllustrationPageDomain,
  makeSelectLifeAssured,
  makeSelectInitialLifeAssured,
  makeSelectProductConfig,
  makeSelectError,
  makeSelectQuoteId,
  makeSelectApplicationId,
  makeSelectBiPdf,
  makeSelectStatus,
  makeSelectReferenceNumber,
  makeSelectCloneStatus,
  makeSelectemailSentStatus,
  makeSelectEmailErrorMessage,
  makeSelectIsCalculateQuotePage,
  makeSelectCompletedDialog,
  makeSelectConfigDetail,
};
